import { Instance, types } from "mobx-state-tree";

export enum ToastMessageType {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  DANGER = "DANGER",
  WARNING = "WARNING",
  PAYMENT = "PAYMENT"
}

/**
 * Enum representing type of full width toast in dashboard
 *
 * Lower values of this enum mean higher priority of being displayed
 */
export enum ToastBarToastType {
  HighPriority,
  NoConnection,
  LowPriority
}

export const ToastMessage = types.model("ToastMessage", {
  type: types.optional(
    types.enumeration<ToastMessageType>("ToastMessageType", Object.values(ToastMessageType)),
    ToastMessageType.INFO
  ),
  message: types.string
});

export const ToastBarMessage = types.compose(
  "ToastBarMessage",
  ToastMessage,
  types.model({
    toastBarToastType: types.optional(types.number, ToastBarToastType.LowPriority)
  })
);

export type IToastBarMessage = Instance<typeof ToastBarMessage>;
